<div class="modal-header" *ngIf="IsModal">
  <h5 class="modal-title" id="editUserLabel" style="font-weight: bold">{{Tipo}}</h5>
  <button type="button" class="close" (click)="Close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [class.modal-body]="IsModal">
  <app-field-viewer *ngIf="environment['Magazzino'] && environment['Magazzino']['CampiEdit']" [(Type)]="Tipo" [Campi]="environment['Magazzino']['CampiEdit']" (OnChange)="ChangeHandler($event)" [(Oggetto)]="Item"></app-field-viewer>
  <div class="card" *ngIf="!environment['Magazzino'] || !environment['Magazzino']['CampiEdit']">
    <div class="card-body">
      <h4>
        <span class=" px-3 font-weight-bold font-14">Inserire nell'environment il campo 'Magazzino.CampiEdit'</span>
      </h4>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">
  <ng-container *ngIf="environment['Magazzino']['Pulsanti']">
    <ng-container *ngFor="let button of environment['Magazzino']['Pulsanti']">
      <button type="button" [ngClass]="button['class']" *ngIf="permission.HasCapacity(button['capacita']) && campoUtility.ButtonShow(button,Item)" (click)='ButtonClick(button)'>
        <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
        <span [ngClass]="button['labelClass']"> {{button['nome'] | translate}} </span>
      </button>
    </ng-container>
  </ng-container>
  <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
  <button type="submit" (click)="Save()" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
    <span class="mr-1 text-white "> Salva </span>
    <i class="far fa-save text-white"></i>
  </button>
  <button type="submit" (click)="Save(true)" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
    <span class="mr-1 text-white "> Salva e chiudi </span>
    <i class="far fa-save text-white"></i>
  </button>
  <button type="submit" (click)="Close()"  style="margin: 0.75px;" class=" btn btn-danger  waves-effect waves-light">
    <span class="mr-1 text-white "> Chiudi </span>
    <i class="far fa-window-close text-white"></i>
  </button>
</div>
